export default __webpack_public_path__ + "static/media/TIBIA_AXIAL.952f1cc8.jpg";